export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  guest: () => import("/app/layouts/guest.vue").then(m => m.default || m)
}